// extracted by mini-css-extract-plugin
module.exports = {"link":"_3HzEgtNDgEWJ2xKJQBuXeg"};